import { createAction } from '@reduxjs/toolkit';
const prefix = `elevio/feedback`;
export const feedbackActions = {
    // Feedback
    ticketAssisted: createAction(`${prefix}/ticketAssisted`),
    haveFeedbackPressed: createAction(`${prefix}/haveFeedbackPressed`),
    feedbackSubmit: createAction(`${prefix}/feedbackSubmit`),
    feedbackReset: createAction(`${prefix}/feedbackReset`),
    feedbackChanged: createAction(`${prefix}/feedbackChanged`),
};
